export default "__VITE_ASSET__BivJ42wJ__ 300w";